import ConversationApplicationContextRecord from "models/view-models/conversations/conversation-application-context-record";
import PromptSuggestionRecord from "models/view-models/conversations/prompt-suggestions/prompt-suggestion-record";
import PromptSuggestionsRecord from "models/view-models/conversations/prompt-suggestions/prompts-suggestions-record";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";
import useFeatureFlags from "utilities/hooks/use-feature-flags";
import PromptSuggestionsService from "utilities/services/prompt-suggestions/prompt-suggestions-service";

const useChatPrompts = (
    applicationContext: ConversationApplicationContextRecord | undefined
) => {
    const { enableCasiPanelPromptSuggestions } = useFeatureFlags();
    const { get: getPromptsQuery } =
        PromptSuggestionsService.useGetPromptsQuery();

    const { data: resultObject, isLoading } = getPromptsQuery({
        enabled: enableCasiPanelPromptSuggestions,
    });

    // Used to determine page
    const { currentPage } = useCurrentPage();
    const { can } = usePageActionPermission(currentPage);

    const currentContextPrompts = getPromptSuggestionsForCurrentContext(
        resultObject?.resultObject,
        applicationContext,
        can(PageAction.Edit)
    );

    return {
        promptSuggestions: enableCasiPanelPromptSuggestions
            ? currentContextPrompts
            : [],
        isLoading,
    };
};

const getPromptSuggestionsForCurrentContext = (
    promptSuggestions?: PromptSuggestionsRecord,
    currentContext?: ConversationApplicationContextRecord,
    canEditPage?: boolean
): PromptSuggestionRecord[] => {
    if (!promptSuggestions) {
        return [];
    }

    switch (currentContext?.currentView?.type) {
        case "Notebooks":
            return !canEditPage
                ? []
                : currentContext.currentView.location?.block
                  ? promptSuggestions.notebooks.block
                  : promptSuggestions.notebooks.page;
        case "Bookview":
            return promptSuggestions.bookview;
        default:
            return [];
    }
};

export default useChatPrompts;
